import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { CheckCircle, Cancel } from "@mui/icons-material";
import colors from "../constants/color";

const CustomAlert = ({ open, severity, message, onClose }) => {
  if (!open) return null;

  const isSuccess = severity === "success";
  const borderColor = isSuccess ? colors.limeGreen : colors.deleteBg;
  const iconColor = isSuccess ? colors.darkGreen : colors.red;
  const buttonColor = isSuccess ? colors.darkGreen : colors.red;
  const buttonHoverColor = isSuccess ? colors.green : colors.darkRed;

  return (
    <Box
      sx={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 9999,
        width: "auto",
        minWidth: { xs: "75vw", sm: 300 },   // smaller box
        maxWidth: "85vw",
      }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          border: `3px solid ${borderColor}`,
          borderRadius: 3,
          padding: 0,
          boxShadow: "0 8px 30px rgba(0,0,0,0.2)",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header Strip */}
        <Box
          sx={{
            backgroundColor: borderColor,
            padding: { xs: "8px 14px", sm: "10px 18px" }, // smaller padding
            display: "flex",
            alignItems: "center",
            gap: 1.5,
          }}
        >
          {/* Icon */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: { xs: 24, sm: 28 },   // smaller icon box
              height: { xs: 24, sm: 28 },
              borderRadius: "50%",
              backgroundColor: "white",
              flexShrink: 0,
            }}
          >
            {isSuccess ? (
              <CheckCircle
                sx={{ color: iconColor, fontSize: { xs: 16, sm: 18 } }} // smaller icon
              />
            ) : (
              <Cancel
                sx={{ color: iconColor, fontSize: { xs: 16, sm: 18 } }}
              />
            )}
          </Box>

          {/* Title */}
          <Typography
            sx={{
              fontSize: { xs: "0.9rem", sm: "1rem" }, // smaller title
              fontWeight: 700,
              color: "white",
              textTransform: "uppercase",
              letterSpacing: "0.4px",
            }}
          >
            {isSuccess ? "Success" : "Error"}
          </Typography>
        </Box>

        {/* Message Content */}
        <Box
          sx={{
            padding: { xs: "12px", sm: "16px" },  // reduced padding
            display: "flex",
            flexDirection: "column",
            gap: { xs: 1.5, sm: 2 },
          }}
        >
          {/* Message Text */}
          <Typography
            sx={{
              fontSize: { xs: "0.85rem", sm: "0.95rem" }, // reduced text size
              fontWeight: 500,
              color: colors.darkBlack,
              lineHeight: 1.4,
              textAlign: "center",
            }}
          >
            {message}
          </Typography>

          {/* OK Button */}
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              variant="contained"
              onClick={onClose}
              sx={{
                backgroundColor: buttonColor,
                color: "white",
                fontWeight: 700,
                borderRadius: 2,
                px: 3,
                py: 0.7,
                fontSize: { xs: "0.8rem", sm: "0.9rem" }, // smaller button text
                minWidth: 90, // smaller button
                textTransform: "uppercase",
                letterSpacing: "0.4px",
                boxShadow: "0 3px 10px rgba(0,0,0,0.12)",
                "&:hover": {
                  backgroundColor: buttonHoverColor,
                  transform: "translateY(-1px)",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.18)",
                },
                transition: "all 0.25s ease",
              }}
            >
              OK
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CustomAlert;
